$(document).ready(function() {
    $('#widget-container .widget-button').mouseover(function(){
        $('#widget-container .widget-button:not(#' + $(this).attr('id') + ')').addClass('fade');
    });
    $('#widget-container .widget-button').mouseout(function(){
        $('#widget-container .widget-button').removeClass('fade');
    });


    $(document).on('click', '#switcher', function () {
        var fields = ['address', 'lat', 'lon', 'postal', 'city', 'subloc', 'establishment', 'country', 'street', 'hnr'];
        for (i = 0; i < fields.length; i++) {
            var temp = $('form#teasersearch [name=from_' + fields[i] + ']').val();
            $('form#teasersearch  [name=from_' + fields[i] + ']').val($('form#teasersearch [name=to_' + fields[i] + ']').val());
            $('form#teasersearch [name=to_' + fields[i] + ']').val(temp);
        }
    });

    if (!checkMobile()) {
        $('#time-input').timepicker({
            'timeFormat': 'H:i',
            'step': 60,
            'className': 'timepicker',
            'orientation': 't'
        });
    }
    if (Modernizr.inputtypes['time'] && checkMobile()) {
        //browser supports native date element -> input omzetten naar time
        //$('input#time-input:not([type=time])').attr('type', 'time');

        $('input#time-input:not([type=time])').focus(function(){
            $(this).attr('type','time');
            $(this).click();
        }).blur(function(){
            $(this).attr('type','text');
        });
    }

});

